/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useSelector, useDispatch } from "react-redux";
import { APISignoutSSO } from '../../api/authSSO.ts';
import { FiMenu } from "react-icons/fi";
import { clearAccessToken, set_language } from "../../core/redux/action";
import SellerNotifications from "./SellerNotifications";

const Header = ({ toggleSidebar }) => {

  let fullName = useSelector((state) => state.fullName);
  if(!fullName)
    fullName = localStorage.getItem('fullName');
  const dispatch = useDispatch()
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const languages = useSelector((state) => state.languages || []);


  console.log("languages", languages)

  const flags = {
    ar: `url(data:image/png;base64,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)`,
    en: `url(data:image/jpeg;base64,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)`
  }
  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        submenu.style.display = "none";
      }
    }
  };

  const handleLogout = async () => {
    try {
      // Call the API to sign out
      await APISignoutSSO({});
      dispatch(clearAccessToken());
      // Clear local storage
      localStorage.removeItem('accessToken'); // add more as needed
  
      // Redirect to signin page or home
      window.location.href = '/signin'; // or use history.push('/signin') if using react-router
    } catch (error) {
      console.error('Logout failed', error);
    }
  };
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "icon";
    link.type = "image/png";
    link.href = t?.[l]?.["logoUrlFav"];//"/favicon.png"; // your favicon path
    document.head.appendChild(link);

    // Optional cleanup: remove the link on unmount to avoid duplicates if component unmounts/remounts
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        const target = e.target.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          slideUpSubmenu();
        }

        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("#app-root")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  return (
    <>
      <div className="header">
     
        {/* Logo */}
        {/* <div className="mobile-hamburger-menu">
          <button className="hamburger-menu" onClick={toggleSidebar}>
            <FiMenu size={24} />
          </button>
        </div> */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          style={{ float: l === 'ar' ? 'right' : '' }}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/orders" className="logo logo-normal">
          {/* <ImageWithBasePath src="assets/img/logo.png" alt="img" /> */}
                    <ImageWithBasePath 
                    src={t?.[l]?.["logoUrl"]}
                    alt="img"
                    absolutePath="true" />
                    {/* <ImageWithBasePath src={t?.[l]?.["logoUrl"]} alt="img" /> */}
            {/* <ImageWithBasePath className={`${l === 'ar' ? 'hidden' : ''}`}  src="assets/img/logo.png" alt="img" /> */}
            {/* <ImageWithBasePath className={`${l === 'en' ? 'hidden' : ''}`}  src="assets/img/logo-ar.png" alt="img" /> */}

          </Link>
          <Link
            id="toggle_btn"
            to="#"
            
            style={{
              right: l === 'ar' ? '95%' : '',
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                ? "none"
                : "",
            }}
            onClick={handlesidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}
        <div
          id="mobile_btn"
          className="mobile_btn"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </div>
        {/* Header Menu */}
        <ul className="nav user-menu"
        style={{display: l === 'ar' ?  "flex":'', gap:l === 'ar' ? "2%":''}}
        >
          {/* Search */}
          <li className="nav-item nav-searchinputs language-mobile">
          
            {/* <SellerNotifications/> */}
       
          </li>
          {/* Select language */}
          <li className="nav-item dropdown language-mobile has-arrow main-drop select-store-dropdown">
           
                  <Link
                    to="#"
                    className="dropdown-toggle nav-link select-store"
                    data-bs-toggle="dropdown"
                  >
                    <span className="user-info"
                      style={{gap: l === 'ar' ? "10px" : '',padding:"3px 30px 0 0"}}
                    >
                      {l === 'ar' ?t?.[l]?.["arabic"]:t?.[l]?.["english"]} 
                    </span>
                  </Link>
                  <div className="dropdown-menu dropdown-menu-right">
                    {languages.map((itm) => (
                      <Link
                        to="#"
                        className="dropdown-item"
                        key={itm.key}
                        style={{
                          width: "100%",
                          height: "20px",
                          padding: "15px",
                        }}
                        onClick={() => {
                          dispatch(set_language(itm.key));
                          localStorage.setItem("language", itm.key);
                          localStorage.setItem("lang", itm.key);
                        }}
                      >
                        {t?.[l]?.[itm.name.toLowerCase()]}
                      </Link>
                    ))}
                  </div>
                    
            {/* <Link
              to="#"
              className="dropdown-toggle nav-link select-store"
              data-bs-toggle="dropdown"
            >
              <span className="user-info"
               style={{gap: l === 'ar' ?  "10px":''}}
              >
                <span className="user-letter"
                style={{
                  backgroundImage: flags[l],
                  backgroundSize: "contain"
                }}
                >
                </span>
                <span className="user-detail">
                  <span className="user-name">{t?.[l]?.["select_language"] || "Select Language"}</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              {
                languages.map((itm) => {
                  return (
                    <Link to="#" className="dropdown-item"
                    key={itm.key}
                    style={{
                      backgroundImage: flags[itm.key],
                      backgroundSize: "20px",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "5px",
                      width: "100%",
                      height: "20px",
                      padding:  "15px",
                    }}
                    onClick={() => {
                      dispatch(set_language(itm.key))
                      localStorage.setItem("language", itm.key)
                    }}
                  >
                    <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>{itm.name}
                  </Link>
                  )
                })
              }
            </div> */}
          </li>
         
          {/* Flag */}
          <li className="nav-item dropdown has-arrow flag-nav nav-item-box hidden">
            <Link
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              to="#"
              role="button"
            >
              {/* <i data-feather="globe" /> */}
              {/* <FeatherIcon icon="globe" /> */}
              <ImageWithBasePath
                src="assets/img/flags/us.png"
                alt="img"
                height={16}
              />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="#" className="dropdown-item active">
                <ImageWithBasePath
                  src="assets/img/flags/us.png"
                  alt="img"
                  height={16}
                />
                English
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/fr.png"
                  alt="img"
                  height={16}
                />{" "}
                French
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/es.png"
                  alt="img"
                  height={16}
                />{" "}
                Spanish
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/de.png"
                  alt="img"
                  height={16}
                />{" "}
                German
              </Link>
            </div>
          </li>
          {/* /Flag */}
          <li className="nav-item nav-item-box language-mobile">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              {/* <i data-feather="maximize" /> */}
              <FeatherIcon icon="maximize" />
            </Link>
          </li>
          <li className="nav-item nav-item-box hidden">
            <Link to="/email">
              {/* <i data-feather="mail" /> */}
              <FeatherIcon icon="mail" />
              <span className="badge rounded-pill">1</span>
            </Link>
          </li>
          {/* Notifications */}
          <li className="nav-item dropdown nav-item-box hidden">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              {/* <i data-feather="bell" /> */}
              <FeatherIcon icon="bell" />
              <span className="badge rounded-pill">2</span>
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti">
                  {" "}
                  Clear All{" "}
                </Link>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message active">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-02.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-03.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Tarah Shropshire</span>{" "}
                            changed the task name{" "}
                            <span className="noti-title">
                              Appointment booking with payment gateway
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-06.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Misty Tison</span>{" "}
                            added{" "}
                            <span className="noti-title">Domenic Houston</span>{" "}
                            and <span className="noti-title">Claire Mapes</span>{" "}
                            to project{" "}
                            <span className="noti-title">
                              Doctor available module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-17.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Rolland Webber</span>{" "}
                            completed task{" "}
                            <span className="noti-title">
                              Patient and Doctor video conferencing
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <ImageWithBasePath
                            alt="img"
                            src="assets/img/profiles/avatar-13.jpg"
                          />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Bernardo Galaviz</span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Private chat module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              2 days ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/activities">View all Notifications</Link>
              </div>
            </div>
          </li>
          {/* /Notifications */}
          <li className="nav-item nav-item-box hidden">
            <Link to="/general-settings">
              {/* <i data-feather="settings" /> */}
              <FeatherIcon icon="settings" />
            </Link>
          </li>
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info"
              style={{gap: l === 'ar' ?  "10px":'', left:l === 'ar' ? "5%":''}}
              >
                <span className="user-letter">
                  <ImageWithBasePath
                    src="assets/img/profiles/avator1.jpg"
                    alt="img"
                    className="img-fluid"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">{fullName}</span>
                  <span className="user-role">{t?.[l]?.["admin"] || "Admin"}</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                {/* <div className="profileset">
                  <span className="user-img">
                    <ImageWithBasePath
                      src="assets/img/profiles/avator1.jpg"
                      alt="img"
                    />
                    <span className="status online" />
                  </span>
                  <div className="profilesets">
                    <h6>John Smilga</h6>
                    <h5>Super Admin</h5>
                  </div>
                </div>
                <hr className="m-0" />
              
                <Link className="dropdown-item" to={route.generalsettings}>
                  <i className="me-2" data-feather="settings" />
                  Settings
                </Link> */}
                 <Link className="dropdown-item" to={route.profile}>
                  <i className="me-2" data-feather="user" /> My Profile
                </Link>
                <hr className="m-0" />
                <Link className="dropdown-item logout pb-0" onClick={handleLogout}>
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  {t?.[l]?.["logout"] || "Logout"}
                </Link>
                
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link className="dropdown-item" to="profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="generalsettings">
              Settings
            </Link> */}
            <Link className="dropdown-item" onClick={handleLogout}>
            {t?.[l]?.["logout"] || "Logout"}
            </Link>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
